import { AppHTTPService } from '../http-service'

export const getAnalytics = async ({
  appId,
  environmentId,
  startDate,
  endDate,
  metrics,
}: {
  appId: string
  environmentId: string
  startDate: string
  endDate: string
  metrics: string
}): Promise<any> => {
  return AppHTTPService.axios.get(
    `${window.flatfile.configService.get(
      'VITE_BASE_API_URL'
    )}/v1/internal/apps/${appId}/analytics?environmentId=${environmentId}&dateRange[startDate]=${startDate}&dateRange[endDate]=${endDate}&metric=${metrics}`
  )
}

export const getAnalyticsList = async ({
  appId,
  environmentId,
  startDate,
  endDate,
  metrics,
  currentPage,
}: {
  appId: string
  environmentId: string
  startDate: string
  endDate: string
  metrics: string
  currentPage: number
}): Promise<any> => {
  return AppHTTPService.axios.get(
    `${window.flatfile.configService.get(
      'VITE_BASE_API_URL'
    )}/v1/internal/apps/${appId}/analyticList?environmentId=${environmentId}&dateRange[startDate]=${startDate}&dateRange[endDate]=${endDate}&metric=${metrics}&pageSize=10&pageNumber=${currentPage}`
  )
}
